import { defineStore } from "pinia";

export const useWorksheets = defineStore("worksheet", {
  state: () => ({
    worksheetId: JSON.parse(localStorage.getItem("worksheetItems")) || [],
    isLoading: false,
    popupMainWorksheet: false,
  }),
  persist: {
    paths: ['worksheetId', 'isLoading']
  },
  getters: {
    getWorksheetId(state) {
      return state.worksheetId;
    },
    getWorksheetIdLength(state) {
      return state.worksheetId.length;
    },
  },
  actions: {
    addWorksheet(data) {
      console.log('addWorksheet', data);
      
      this.worksheetId = data;
    },
    changeOrder(e) {
      console.log('changeOrder');

      const { oldIndex, newIndex, element } = e;
      
      const list = [...this.worksheetId]
      
      const itemIndex = list.findIndex(
        (item) => item.Uid === element.Uid
      );

      if (itemIndex !== -1) {
        const [movedItem] = list.splice(itemIndex, 1);

        list.splice(newIndex, 0, movedItem);

        this.worksheetId = list
      } else {
        console.error("Item not found in worksheetId");
      }
    },
    changeWorksheet(id, data) {
      console.log('changeWorksheet');

      const index = this.worksheetId.findIndex(
        (worksheet) => worksheet.Uid === id,
      );
      if (index !== -1) {
        this.worksheetId[index] = data;
      }
    },
    deleteWorksheet(index) {
      console.log('deleteWorksheet');

      this.worksheetId.splice(index, 1);
    },
    toggleWorksheet(Mid, Uid) {
      console.log('toggleWorksheet');

      const index = this.worksheetId.findIndex(
        (worksheet) => worksheet.Mid === Mid && worksheet.Uid === Uid,
      );
      
      if (index !== -1) {
        this.worksheetId.splice(index, 1);
      } else {
        const newWorksheet = { Mid, Uid };
        this.worksheetId.push(newWorksheet);
      }
    },
    ensureWorksheetsLength() {
      console.log('ensureWorksheetsLength');

      if(this.worksheetId.length > 3) {
        this.worksheetId = this.worksheetId.slice(0, 3);
      }
    },
    cleanInvalidWorksheets(validData) {     
      console.log('cleanInvalidWorksheets', validData);
      console.log('this.worksheetId', this.worksheetId);
       
      this.worksheetId = this.worksheetId.filter((worksheet) =>
        validData.some((item) =>
          item.modelId === worksheet.Mid &&
          item.units.some((unit) => unit.suiteId === worksheet.Uid)
        )
      );
      console.log('this.worksheetId 2', this.worksheetId);
    },
  },
});
